module.exports = __webpack_public_path__ + "static/media/segments.8d352c58.gif";